/* eslint-disable no-restricted-globals */
import React, { useEffect, useContext } from 'react';
import { postJSONPS } from '@cd/utils';
import { CenterProgress } from '../component/CenterProgress';
import { store } from './store';
import { either } from '@cd/utils';

function Signout() {
	const { dispatch } = useContext(store);
	useEffect(() => {
		postJSONPS('GET', '/get/logout/url', {}).then(
			either(
				e => {
					dispatch({ type: 'post error', e });
				},
				({ url }) => {
					location.href = url;
				}
			)
		);
	}, []);
	return <CenterProgress />;
}

export default Signout;
